module.exports = __webpack_public_path__ + "static/media/iconClock.82babee6.svg";